import React, { Component, Fragment } from "react";
import MultiLine from "../../../../d3Components/MultiLineChart/multiLine";
import Legendhtml from "../../../../d3Components/MultiLineChart/Legendhtml";
import Helper from "../helper";
import ContainerDimensions from "react-container-dimensions";

class MultiLineHolder extends Component {
  state = {
    seriesOptions: [],
  };

  componentDidMount() {
    let data = this.props.res;
    let seriesOptions = Helper.styleFormatData(data);
    this.setState({
      seriesOptions,
    });
  }
  componentWillReceiveProps(props) {
    let data = props.res;
    let seriesOptions = Helper.styleFormatData(data);
    this.setState({
      seriesOptions,
    });
  }
  render() {
    const { seriesOptions } = this.state;

    return (
      <Fragment>
        <div className="row">
          <div style={{ overflowX: "auto" }}>
            {seriesOptions.length > 0 ? (
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    {width > 0 ? (
                      <MultiLine
                        data={seriesOptions}
                        id={"multi2"}
                        lineStyle={"Multiline2"}
                        circleStyle={"Circle2"}
                        width={width - 50}
                      />
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            ) : null}
          </div>
          {seriesOptions.length > 0 ? (
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <Legendhtml
                      data={seriesOptions}
                      legendId={"MultilineLegend2"}
                      width={width}
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default MultiLineHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/StyleExposure/multilineHolder.jsx